import { render, staticRenderFns } from "./Diamond.vue?vue&type=template&id=4a3eb1b0&scoped=true&"
import script from "./Diamond.vue?vue&type=script&lang=js&"
export * from "./Diamond.vue?vue&type=script&lang=js&"
import style0 from "./Diamond.vue?vue&type=style&index=0&id=4a3eb1b0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a3eb1b0",
  null
  
)

export default component.exports